import React from "react";
import { FaAward, FaUserTie } from "react-icons/fa6";
import { RiMedalFill } from "react-icons/ri";
import {
  FaHouseUser,
  FaUserCheck,
  FaUserCog,
  FaRegFileArchive,
  FaFileInvoice,
  FaUserFriends,
  FaRegSun,
  FaBalanceScale,
  FaChartLine,
} from "react-icons/fa";
import {
  BsFillTicketDetailedFill,
  BsFillAwardFill,
  BsFillFileEarmarkMedicalFill,
  BsClipboard2CheckFill,
} from "react-icons/bs";
import { HiDocumentReport } from "react-icons/hi";
import { GiOnTarget } from "react-icons/gi";
import { ImTicket, ImTree } from "react-icons/im";
import { AiOutlineDashboard } from "react-icons/ai";
import { MdOutlinePendingActions } from "react-icons/md";
import config from "../../permission/config.json";
import { getResource } from "../../util/getResourcePermission";

// Import all custom icons
import InOuticon from "./sidebarIcons/inOutIcon";
import LeaveIcon from "./sidebarIcons/LeaveIcon";
import AttendanceIcon from "./sidebarIcons/attendanceIcon";
import EmployeesmasterIcon from "./sidebarIcons/employeesmasterIcon";
import AssetsIcon from "./sidebarIcons/AssetsIcon";
import SeparationIcon from "./sidebarIcons/separationIcon";
import LeaveManagement from "./sidebarIcons/LeaveManagement";
import AuditmasterIcon from "./sidebarIcons/AuditMaster";
import NewemployIcon from "./sidebarIcons/NewemployIcon";
import JobopeningIcon from "./sidebarIcons/JobopeningIcon";
import RankingIcon from "./sidebarIcons/RankingIcon";
import OnboardingIcon from "./sidebarIcons/OnboardingIcon";
import AchivementIcon from "./sidebarIcons/AchivementIcon";
import TeamInfoIcon from "./sidebarIcons/TeamInfoIcon";
import AuditIcon from "./sidebarIcons/AuditIcon";
import PermissionmanagerIcon from "./sidebarIcons/PermissionmanagerIcon";
import DepartmentIcon from "./sidebarIcons/DepartmentIcon";
import InventoryIcon from "./sidebarIcons/inventoryIcon";
import ReportsIcon from "./sidebarIcons/ReportsIcon";

const userdata = JSON.parse(localStorage.getItem("user_data"));

// Define all menu items with their configurations
const MENU_ITEMS = {
  dashboard: {
    key: "User Dashboard",
    path: "/dashboard",
    icon: <AiOutlineDashboard />,
    title: "sidebar.User_Dashboard",
    submenu: false,
    permission: [],
  },
  adminDashboard: {
    key: "Admin Dashboard",
    path: "/dashboard",
    icon: <AiOutlineDashboard />,
    title: "sidebar.Admin_Dashboard",
    submenu: false,
    permission: [],
  },
  leaveApplication: {
    key: "manage-leave-application",
    path: "/leave-application",
    icon: <LeaveIcon />,
    title: "sidebar.leave-application",
    submenu: false,
    permission: [config.RESOURCES.LEAVE],
  },
  resignation: {
    key: "resignation",
    path: "/resignation",
    icon: <SeparationIcon />,
    title: "sidebar.resignation",
    submenu: false,
    permission: [config.RESOURCES.SEPARATION],
  },
  lastWorkingDay: {
    key: "last-working-day-emps",
    path: "/last-working-day-emps",
    icon: <SeparationIcon />,
    title: "Last Working Day List",
    submenu: false,
    permission: [config.RESOURCES.LAST_WORKING_DAY_LIST],
  },
  attendanceRegularization: {
    key: "Attendance Regularization",
    path: "/employee-attendance-regularization",
    icon: <AttendanceIcon />,
    title: "sidebar.Attendence_Regularization",
    submenu: false,
    permission: [config.RESOURCES.ATTENDANCE_REGULARIZATION],
  },
  tickets: {
    key: "tickets",
    path: "/tickets",
    icon: <ImTicket />,
    title: "sidebar.tickets",
    submenu: false,
    permission: [config.RESOURCES.TICKET],
  },
  userAssets: {
    key: "assets",
    path: "/user-assets",
    icon: <AssetsIcon />,
    title: "sidebar.user-assets",
    submenu: false,
    permission: [config.RESOURCES.MY_ASSETS],
  },
  userReports: {
    key: "user-reports",
    path: "/user-reports",
    icon: <ReportsIcon />,
    title: "sidebar.user-reports",
    submenu: false,
    permission: [config.RESOURCES.ATTENDANCE_REPORT],
  },
  adminReports: {
    key: "admin-reports",
    path: "/admin-reports",
    icon: <ReportsIcon />,
    title: "sidebar.admin-reports",
    submenu: false,
    permission: [config.RESOURCES.EMPLOYEE_REPORT],
  },
  individualRanking: {
    key: "individual-ranking",
    path: "/individual-rank",
    icon: <RankingIcon />,
    title: "sidebar.individual-rank",
    submenu: false,
    permission: [config.RESOURCES.RANKING],
  },
  goals: {
    key: "goals",
    path: "/goals",
    icon: <GiOnTarget />,
    title: "sidebar.create-goals",
    submenu: false,
    permission: [config.RESOURCES.MY_GOAL],
  },
  jobOpening: {
    key: "Job Opening",
    path: "/jobs/openings",
    icon: <JobopeningIcon />,
    title: "sidebar.admin-jobopening",
    submenu: false,
    permission: [config.RESOURCES.JOB_OPENING],
  },
  organizationPolicy: {
    key: "organization-policy",
    path: "/organization-policy",
    icon: <BsClipboard2CheckFill />,
    title: "sidebar.organization-policies",
    submenu: false,
    permission: [],
  },
  inventory: {
    key: "inventory",
    path: "/inventory",
    icon: <InventoryIcon />,
    title: "sidebar.user-assetstabpane",
    submenu: false,
    permission: [config.RESOURCES.INVENTORY],
  },
  manageTickets: {
    key: "managetickets",
    path: "/manage-tickets",
    icon: <BsFillTicketDetailedFill />,
    title: "sidebar.manage-tickets",
    submenu: false,
    permission: [config.RESOURCES.MANAGE_TICKET],
  },
  auditMaster: {
    key: "Audit Master",
    path: "/auditmaster",
    icon: <AuditmasterIcon />,
    title: "Audit Master",
    submenu: false,
    permission: [config.RESOURCES.AUDIT_MASTER],
  },
  auditHistory: {
    key: "Audits",
    path: "/audit-history",
    icon: <FaFileInvoice />,
    title: "Audits",
    submenu: false,
    permission: [config.RESOURCES.AUDITS],
  },
  auditPerformance: {
    key: "auditperformance",
    path: "/auditperformance",
    icon: <AuditIcon />,
    title: "Audit Performance",
    submenu: false,
    permission: [config.RESOURCES.AUDITS_PERFORMANCE],
  },
  auditHead: {
    key: "auditHead",
    path: "/audithead",
    icon: <AuditmasterIcon />,
    title: "Audit Head",
    submenu: false,
    permission: [config.RESOURCES.AUDIT_HEAD],
  },
  employeeMaster: {
    key: "employee-master",
    path: "/employee-master",
    icon: <EmployeesmasterIcon />,
    title: "sidebar.employee-master",
    submenu: false,
    permission: [config.RESOURCES.EMPLOYEE_MASTER],
  },
  employeeInOut: {
    key: "employee-in-out",
    path: "/employee-in-out",
    icon: <InOuticon />,
    title: "sidebar.Employee-In-Out",
    submenu: false,
    permission: [config.RESOURCES.EMPLOYEE_IN_OUT],
  },
  myInOut: {
    key: "MY-IN-OUT",
    path: "/my-in-out",
    icon: <InOuticon />,
    title: "sidebar.MY-IN-OUT",
    submenu: false,
    permission: [config.RESOURCES.EMPLOYEE_IN_OUT],
  },
  adminLeaveApproval: {
    key: "admin-leave-approval",
    path: "/admin-leave-approval",
    icon: <LeaveManagement />,
    title: "sidebar.admin-leave-management",
    submenu: false,
    permission: [config.RESOURCES.ADMIN_LEAVE_MANAGEMENT],
  },
  pendingTask: {
    key: "pendingtask",
    path: "/pending-task-list",
    icon: <MdOutlinePendingActions />,
    title: "sidebar.pending-task",
    submenu: false,
    permission: [config.RESOURCES.PENDING_TASK],
  },
  reportingManagersPendingTask: {
    key: "reporting-managers-pending-task",
    path: "/reporting-managers-pending-task",
    icon: <MdOutlinePendingActions />,
    title: "sidebar.rm-pending-task",
    submenu: false,
    permission: [config.RESOURCES.RM_PENDING_TASK],
  },
  adminRegularization: {
    key: "admin-regularizatrion",
    path: "/admin-regularizatrion",
    icon: <FaUserCog />,
    title: "sidebar.admin-regularizatrion",
    submenu: false,
    permission: [config.RESOURCES.ADMIN_REGULARIZATION],
  },
  achievements: {
    key: "achivements",
    path: "/achivements",
    icon: <BsFillAwardFill />,
    title: "sidebar.achivements",
    submenu: false,
    permission: [config.RESOURCES.ACHIEVEMENTS],
  },
  achievementsAlt: {
    key: "achivements",
    path: "/achivements",
    icon: <AchivementIcon />,
    title: "sidebar.achivements",
    submenu: false,
    permission: [config.RESOURCES.ACHIEVEMENTS],
  },
  permission: {
    key: "permission",
    path: "/permission-manager",
    icon: <PermissionmanagerIcon />,
    title: "sidebar.permission",
    submenu: false,
    permission: [config.RESOURCES.SETTINGS],
  },
  adminDepartment: {
    key: "admin-department",
    path: "/admin-department",
    icon: <DepartmentIcon />,
    title: "sidebar.Department",
    submenu: false,
    permission: [config.RESOURCES.DEPARTMENTS],
  },
  adminSubDepartment: {
    key: "admin-sub-department",
    path: "/admin-sub-department",
    icon: <DepartmentIcon />,
    title: "sidebar.SubDepartment",
    submenu: false,
    permission: [config.RESOURCES.DEPARTMENTS],
  },
  meetingRoomMaster: {
    key: "meeting-room-master",
    path: "/meeting-room-master",
    icon: <DepartmentIcon />,
    title: "sidebar.MeetingRoomMaster",
    submenu: false,
    permission: [config.RESOURCES.MEETING_ROOM_MASTER],
  },
  // Kept for the route/permission mapping, but no longer listed in any role's
  // sidebar — booking is reached from the dashboard header button instead.
  bookMeetingRoom: {
    key: "book-meeting-room",
    path: "/book-meeting-room",
    icon: <InOuticon />,
    title: "sidebar.BookMeetingRoom",
    submenu: false,
    permission: [config.RESOURCES.MEETING_ROOM_BOOKING],
  },
  skills: {
    key: "skills",
    path: "/skills",
    title:"sidebar.skills",
    submenu: false,
    permission: [],
  },
  adminDesignation: {
    key: "admin-designation",
    path: "/admin-designation",
    icon: <FaUserCog />,
    title: "sidebar.designation",
    submenu: false,
    permission: [config.RESOURCES.DESIGNATION],
  },
  sourceOfHireMaster: {
    key: "source-of-hire-master",
    path: "/source-of-hire-master",
    icon: <FaUserCog />,
    title: "sidebar.sourceOfHire",
    submenu: false,
    permission: [config.RESOURCES.DESIGNATION],
  },
  leaveMaster: {
    key: "leave-master",
    path: "/admin-leave-master",
    icon: <FaUserCog />,
    title: "sidebar.admin-leave-master",
    submenu: false,
    permission: [config.RESOURCES.LEAVE_MASTER],
  },
  employeeLeaveBalance: {
    key: "employee-leave-balance",
    path: "/employee-leave-balance",
    icon: <FaHouseUser />,
    title: "sidebar.employee-leave-balance",
    submenu: false,
    permission: [config.RESOURCES.MANAGE_LEAVE_BALANCE],
  },
  candidateApproval: {
    key: "candidate-approvel",
    path: "/candidate-approval",
    icon: <FaUserTie />,
    title: "sidebar.candidate-approvel",
    submenu: false,
    permission: [config.RESOURCES.ON_BOARDING_INITIATION],
  },
  candidateList: {
    key: "candidate-list",
    path: "/candidate-list",
    icon: <FaUserCheck />,
    title: "sidebar.candidate-approvel-list",
    submenu: false,
    permission: [config.RESOURCES.CANDIDATE_APPROVAL],
  },
  onboardingInitiation: {
    key: "initiation",
    path: "/onboarding-initiation",
    icon: <OnboardingIcon />,
    title: "sidebar.onboarding-initiation",
    submenu: false,
    permission: [config.RESOURCES.ON_BOARDING_INITIATION],
  },
  docApproveList: {
    key: "doc-approve-list",
    path: "/doc-approve-list",
    icon: <FaRegFileArchive />,
    title: "sidebar.doc-approve-list",
    submenu: false,
    permission: [config.RESOURCES.ON_BOARDING_DOC_APPROVAL_LIST],
  },
  newJoineesList: {
    key: "new-joinees-list",
    path: "/new-joinees-list",
    icon: <NewemployIcon />,
    title: "sidebar.new-joinees-list",
    submenu: false,
    permission: [config.RESOURCES.NEW_JOINEES],
  },
  newJoineesListAlt: {
    key: "new-joinees-list",
    path: "/new-joinees",
    icon: <NewemployIcon />,
    title: "sidebar.new-joinees-list",
    submenu: false,
    permission: [config.RESOURCES.NEW_JOINEES],
  },
  holidays: {
    key: "holidays",
    path: "/holidays",
    icon: <FaRegFileArchive />,
    title: "sidebar.holidays",
    submenu: false,
    permission: [config.RESOURCES.HOLIDAYS],
  },
  policies: {
    key: "policies",
    path: "/policies",
    icon: <BsFillFileEarmarkMedicalFill />,
    title: "sidebar.policies",
    submenu: false,
    permission: [config.RESOURCES.POLICIES],
  },
  audits: {
    key: "Audits",
    path: "/audits",
    icon: <AuditIcon />,
    title: "Audits",
    submenu: false,
    permission: [config.RESOURCES.AUDIT_MASTER],
  },
  organizationTree: {
    key: "organisationtree",
    path: "/organization-view",
    icon: <ImTree />,
    title: "sidebar.organisation-tree",
    submenu: false,
    permission: [],
  },
  appSettings: {
    key: "appsettings",
    path: "/app-setting",
    icon: <FaRegSun />,
    title: "sidebar.app-setting",
    submenu: false,
    permission: [config.RESOURCES.SETTINGS],
  },
  resignationEmployeeList: {
    key: "resignation-employee-list",
    path: "/resignation-employee-list",
    icon: <SeparationIcon />,
    title: "sidebar.resignation-employee-list",
    submenu: false,
    permission: [config.RESOURCES.SEPARATION_MANAGEMENT],
  },
  manageTeamRegularization: {
    key: "ManageTeamRegularization",
    path: "/manage-team-regularization",
    icon: <FaUserFriends />,
    title: "sidebar.ManageTeamRegularization",
    submenu: false,
    permission: [config.RESOURCES.TEAM_REGULARIZATION],
  },
  userLeaveApproval: {
    key: "user-leave-approval",
    path: "/user-leave-approve",
    icon: <LeaveManagement />,
    title: "sidebar.user-leave-management",
    submenu: false,
    permission: [config.RESOURCES.LEAVE_MANAGEMENT],
  },
  viewEmployeeDetails: {
    key: "view-employee-details",
    path: "/viewEmployeeDetails",
    icon: <FaHouseUser />,
    title: "sidebar.employee-details",
    submenu: false,
    permission: [config.RESOURCES.EMPLOYEE_DETAILS],
  },
  billReimbursement: {
    key: "Bill Reimbursement",
    path: "/bill-reimbursement",
    icon: <HiDocumentReport />,
    title: "sidebar.bill-reimbursement",
    submenu: false,
    permission: [config.RESOURCES.BILLREIMBURSEMENT],
  },
  subscription: {
    key: "subscription",
    path: "/subscription",
    icon: <i className="fas fa-crown" />,
    title: "sidebar.subscription",
    submenu: false,
    permission: [config.RESOURCES.SUBSCRIPTION],
  },
  candidateApprovalAlt: {
    key: "candidate-approvel",
    path: "/candidate-approval",
    icon: <FaUserTie />,
    title: "sidebar.candidate-approvel-list",
    submenu: false,
    permission: [config.RESOURCES.ON_BOARDING_INITIATION],
  },
  candidateListAlt: {
    key: "candidate-list",
    path: "/candidate-list",
    icon: <FaUserCheck />,
    title: "sidebar.candidate-approvel",
    submenu: false,
    permission: [config.RESOURCES.CANDIDATE_APPROVAL],
  },
  auditHistoryAlt: {
    key: "Audits",
    path: "/audit-history",
    icon: <AuditIcon />,
    title: "Audit History",
    submenu: false,
    permission: [],
  },
  waffleDashboard: {
    key: "karma-send",
    path: "/Waffle",
    icon: <i className="fas fa-stroopwafel" />,
    title: "Waffle",
    submenu: false,
    permission: [config.RESOURCES.WAFFLE],
  },
  mood_analytics:{
    key: "mood-analytics",
    path: "/mood-list",
    icon: <i className="fas fa-stroopwafel" />,
    title: "Mood Analytics",
    submenu: false,
    permission: [],
  },
  project_overview:{
    key: "project-overview",
    path: "/project-overview",
    icon: <i className="fas fa-stroopwafel" />,
    title: "Project Overview",
    submenu: false,
    permission: [],
  },
  mira:{
    key: "mira-ai",
    path: "/mira",
    icon: <AiOutlineDashboard />,
    title: "sidebar.AI",
    submenu: false,
    permission: [],
  },
  kpiKra: {
    key: "kpi-kra",
    path: "/kpi-kra",
    icon: <GiOnTarget />,
    title: "KPI / KRA",
    submenu: false,
    permission: [config.RESOURCES.KPI_KRA],
  },
  kpiReviewer: {
    key: "reviewer-panel",
    path: "/reviewer-panel",
    icon: <GiOnTarget />,
    title: "KPI Reviewer",
    submenu: false,
    permission: [config.RESOURCES.KPI_REVIEWER],
  },
  kpiEmployee: {
    key: "kpis",
    path: "/kpis",
    icon: <GiOnTarget />,
    title: "My KPIs",
    submenu: false,
    permission: [config.RESOURCES.KPI_EMPLOYEE],
  },
  performanceDashboard: {
    key: "performance-dashboard",
    path: "/performance/dashboard",
    icon: <AiOutlineDashboard />,
    title: "sidebar.performance-dashboard",
    submenu: false,
    permission: [config.RESOURCES.PERFORMANCE_DASHBOARD],
  },
  performanceCycles: {
    key: "performance-cycles",
    path: "/performance/cycles",
    icon: <MdOutlinePendingActions />,
    title: "sidebar.performance-cycles",
    submenu: false,
    permission: [config.RESOURCES.PERFORMANCE_CYCLES],
  },
  performanceTemplates: {
    key: "performance-templates",
    path: "/performance/templates",
    icon: <HiDocumentReport />,
    title: "sidebar.performance-templates",
    submenu: false,
    permission: [config.RESOURCES.PERFORMANCE_TEMPLATES],
  },
  performanceGoals: {
    key: "performance-goals",
    path: "/performance/goals",
    icon: <MdOutlinePendingActions />,
    title: "sidebar.performance-goals",
    submenu: false,
    permission: [config.RESOURCES.PERFORMANCE_GOALS],
  },
  performanceKpi: {
    key: "performance-kpi-kra",
    path: "/performance/kpi-kra",
    icon: <GiOnTarget />,
    title: "sidebar.performance-kpi",
    submenu: false,
    permission: [config.RESOURCES.PERFORMANCE_KPI_KRA],
  },
  performanceAppraisal: {
    key: "performance-appraisal",
    path: "/performance/appraisal",
    icon: <GiOnTarget />,
    title: "sidebar.performance-appraisal",
    submenu: false,
    permission: [config.RESOURCES.PERFORMANCE_APPRAISAL],
  },
  performanceReports: {
    key: "performance-reports",
    path: "/performance/reports",
    icon: <HiDocumentReport />,
    title: "sidebar.performance-reports",
    submenu: false,
    permission: [config.RESOURCES.PERFORMANCE_REPORTS],
  },

};

// Dynamic submenu generators
const createWaffleSubmenu = (keyPrefix = "sub22") => ({
  icon: <i className="fas fa-stroopwafel" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Waffle",
  submenu: true,
  subMenuInfo: [
    {
      key: "karma-send",
      path: "/Waffle",
      title: "sidebar.karmaSend",
      submenu: false,
      permission: [config.RESOURCES.WAFFLE],
    },
    {
      key: "karma-weightage",
      path: "/Waffle-weightage",
      icon: <FaBalanceScale />,
      title: "sidebar.karmaWeightage",
      submenu: false,
      permission: [config.RESOURCES.WAFFLE_WEIGHTAGE],
    },
    ...(getResource(config.RESOURCES.WAFFLE, ["create"])
      ? [
          {
            key: "karma-karmaCategory",
            path: "/Waffle-category",
            icon: <RiMedalFill />,
            title: "sidebar.karmaCategory",
            submenu: false,
            permission: [config.RESOURCES.WAFFLE],
          },
        ]
      : []),
    ...(getResource(config.RESOURCES.WAFFLE_REWARD, ["read"])
      ? [
          {
            key: "karma-reward-approvel",
            path: "/Waffle-reward-approvel",
            icon: <RiMedalFill />,
            title: "sidebar.karmaRewardApprovel",
            submenu: false,
            permission: [config.RESOURCES.WAFFLE_REWARD],
          },
        ]
      : []),
  ],
});

const createWaffleSubmenuForAccount = (keyPrefix = "sub17") => ({
  icon: <i className="fas fa-stroopwafel" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Waffle",
  submenu: true,
  subMenuInfo: [
    {
      key: "karma-send",
      path: "/Waffle",
      icon: <i className="fas fa-stroopwafel" />,
      title: "sidebar.karmaSend",
      submenu: false,
      permission: [config.RESOURCES.WAFFLE],
    },
    {
      key: "karma-weightage",
      path: "/Waffle-weightage",
      icon: <FaBalanceScale />,
      title: "sidebar.karmaWeightage",
      submenu: false,
      permission: [config.RESOURCES.WAFFLE_WEIGHTAGE],
    },
    ...(getResource(config.RESOURCES.WAFFLE, ["create"])
      ? [
          {
            key: "karma-karmaCategory",
            path: "/Waffle-category",
            icon: <RiMedalFill />,
            title: "sidebar.karmaCategory",
            submenu: false,
            permission: [config.RESOURCES.WAFFLE],
          },
        ]
      : []),
    ...(getResource(config.RESOURCES.WAFFLE_REWARD, ["read"])
      ? [
          {
            key: "karma-reward-approvel",
            path: "/Waffle-reward-approvel",
            icon: <RiMedalFill />,
            title: "sidebar.karmaRewardApprovel",
            submenu: false,
            permission: [config.RESOURCES.WAFFLE_REWARD],
          },
        ]
      : []),
  ],
});

const createWaffleSubmenuForIntern = (keyPrefix = "sub17") => ({
  icon: <i className="fas fa-stroopwafel" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Waffle",
  submenu: true,
  subMenuInfo: [
    {
      key: "karma-send",
      path: "/Waffle",
      icon: <i className="fas fa-stroopwafel" />,
      title: "sidebar.karmaSend",
      submenu: false,
      permission: [config.RESOURCES.WAFFLE],
    },
    {
      key: "karma-reward",
      path: "/Waffle-reward",
      icon: <FaAward />,
      title: "sidebar.karmaReward",
      submenu: false,
      permission: [config.RESOURCES.WAFFLE_REWARD],
    },
    {
      key: "karma-weightage",
      path: "/Waffle-weightage",
      icon: <FaAward />,
      title: "sidebar.karmaWeightage",
      submenu: false,
      permission: [config.RESOURCES.WAFFLE_WEIGHTAGE],
    },
    ...(getResource(config.RESOURCES.WAFFLE_REWARD, ["read"])
      ? [
          {
            key: "karma-reward-approvel",
            path: "/Waffle-reward-approvel",
            icon: <RiMedalFill />,
            title: "sidebar.karmaRewardApprovel",
            submenu: false,
            permission: [config.RESOURCES.WAFFLE_REWARD],
          },
          {
            key: "karma-karmaCategory",
            path: "/Waffle-category",
            icon: <RiMedalFill />,
            title: "sidebar.karmaCategory",
            submenu: false,
            permission: [config.RESOURCES.WAFFLE_REWARD],
          },
        ]
      : []),
  ],
});

const createWaffleSubmenuForHR = (keyPrefix = "sub21") => ({
  icon: <i className="fas fa-stroopwafel" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Waffle",
  submenu: true,
  subMenuInfo: [
    {
      key: "karma-send",
      path: "/Waffle",
      title: "sidebar.karmaSend",
      submenu: false,
      permission: [config.RESOURCES.WAFFLE],
    },
    {
      key: "karma-weightage",
      path: "/Waffle-weightage",
      title: "sidebar.karmaWeightage",
      submenu: false,
      permission: [config.RESOURCES.WAFFLE_WEIGHTAGE],
    },
    {
      key: "karma-summary",
      path: "/Waffle-summary",
      title: "sidebar.karmaSummary",
      submenu: false,
      permission: [],
    },
    ...(getResource(config.RESOURCES.WAFFLE, ["create"])
      ? [
          {
            key: "karma-karmaCategory",
            path: "/Waffle-category",
            title: "sidebar.karmaCategory",
            submenu: false,
            permission: [config.RESOURCES.WAFFLE],
          },
        ]
      : []),
    ...(getResource(config.RESOURCES.WAFFLE_REWARD, ["read"])
      ? [
          {
            key: "karma-reward-approvel",
            path: "/Waffle-reward-approvel",
            title: "sidebar.karmaRewardApprovel",
            submenu: false,
            permission: [config.RESOURCES.WAFFLE_REWARD],
          },
        ]
      : []),
  ],
});

const createWaffleSubmenuForAssistantRM = (keyPrefix = "sub17") => ({
  icon: <i className="fas fa-stroopwafel" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Waffle",
  submenu: true,
  subMenuInfo: [
    {
      key: "karma-send",
      path: "/Waffle",
      title: "sidebar.karmaSend",
      submenu: false,
      permission: [config.RESOURCES.WAFFLE],
    },
    {
      key: "karma-weightage",
      path: "/Waffle-weightage",
      icon: <FaBalanceScale />,
      title: "sidebar.karmaWeightage",
      submenu: false,
      permission: [config.RESOURCES.WAFFLE_WEIGHTAGE],
    },
    ...(getResource(config.RESOURCES.WAFFLE, ["create"])
      ? [
          {
            key: "karma-karmaCategory",
            path: "/Waffle-category",
            title: "sidebar.karmaCategory",
            submenu: false,
            permission: [config.RESOURCES.WAFFLE],
          },
        ]
      : []),
    ...(getResource(config.RESOURCES.WAFFLE_REWARD, ["read"])
      ? [
          {
            key: "karma-reward-approvel",
            path: "/Waffle-reward-approvel",
            title: "sidebar.karmaRewardApprovel",
            submenu: false,
            permission: [config.RESOURCES.WAFFLE_REWARD],
          },
        ]
      : []),
  ],
});

const createAuditSubmenu = (keyPrefix = "sub20") => ({
  icon: <AuditIcon />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Audit",
  submenu: true,
  subMenuInfo: [
    {
      key: "Audit Master",
      path: "/auditmaster",
      title: "Audits Master",
      submenu: false,
      permission: [config.RESOURCES.AUDIT_MASTER],
    },
    {
      key: "Audits",
      path: "/audits",
      title: "Audits",
      submenu: false,
      permission: [config.RESOURCES.AUDITS],
    },
    {
      key: "auditperformance",
      path: "/auditperformance",
      title: "Audit Performance",
      submenu: false,
      permission: [config.RESOURCES.AUDITS_PERFORMANCE],
    },
    {
      key: "auditHead",
      path: "/auditHead",
      title: "Audit Head",
      submenu: false,
      permission: [config.RESOURCES.AUDIT_HEAD],
    },
  ],
});

const createAuditSubmenuForHR = (keyPrefix = "sub20") => ({
  icon: <AuditIcon />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Audit",
  submenu: true,
  subMenuInfo: [
    {
      key: "Audit",
      path: "/audit-history",
      title: "Audit History",
      submenu: false,
      permission: [config.RESOURCES.AUDITS],
    },
    {
      key: "Audit Master",
      path: "/auditmaster",
      title: "Audits Master",
      submenu: false,
      permission: [config.RESOURCES.AUDIT_MASTER],
    },
    {
      key: "Audits",
      path: "/audits",
      title: "Audits",
      submenu: false,
      permission: [config.RESOURCES.AUDITS],
    },
    {
      key: "auditperformance",
      path: "/auditperformance",
      title: "Audit Performance",
      submenu: false,
      permission: [config.RESOURCES.AUDITS_PERFORMANCE],
    },
    {
      key: "auditHead",
      path: "/auditHead",
      title: "Audit Head",
      submenu: false,
      permission: [config.RESOURCES.AUDIT_HEAD],
    },
  ],
});

const createKpiSubmenu = (keyPrefix = "sub-kpi") => ({
  icon: <GiOnTarget />,
  className: "main-submenu",
  key: keyPrefix,
  title: "KPI / KRA",
  submenu: true,
  subMenuInfo: [
    ...(getResource(config.RESOURCES.KPI_KRA, ["read"]) ? [MENU_ITEMS.kpiKra] : []),
    ...(getResource(config.RESOURCES.KPI_REVIEWER, ["read"]) ? [MENU_ITEMS.kpiReviewer] : []),
    ...(getResource(config.RESOURCES.KPI_EMPLOYEE, ["read"]) ? [MENU_ITEMS.kpiEmployee] : []),
  ],
});

const createPerformanceSubmenu = (keyPrefix = "sub-performance") => ({
  icon: <FaChartLine />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Performance",
  submenu: true,
  subMenuInfo: [
    ...(getResource(config.RESOURCES.PERFORMANCE_DASHBOARD, ["read"]) ? [MENU_ITEMS.performanceDashboard] : []),
    ...(getResource(config.RESOURCES.PERFORMANCE_CYCLES, ["read"]) ? [MENU_ITEMS.performanceCycles] : []),
    ...(getResource(config.RESOURCES.PERFORMANCE_TEMPLATES, ["read"]) ? [MENU_ITEMS.performanceTemplates] : []),
    ...(getResource(config.RESOURCES.PERFORMANCE_GOALS, ["read"]) ? [MENU_ITEMS.performanceGoals] : []),
    ...(getResource(config.RESOURCES.PERFORMANCE_KPI_KRA, ["read"]) ? [MENU_ITEMS.performanceKpi] : []),
    ...(getResource(config.RESOURCES.PERFORMANCE_APPRAISAL, ["read"]) ? [MENU_ITEMS.performanceAppraisal] : []),
    ...(getResource(config.RESOURCES.PERFORMANCE_REPORTS, ["read"]) ? [MENU_ITEMS.performanceReports] : []),
  ],
});

// Gating condition for the Performance submenu: visible if the user can read any performance resource
const hasPerformanceAccess = () =>
  getResource(config.RESOURCES.PERFORMANCE_DASHBOARD, ["read"]) ||
  getResource(config.RESOURCES.PERFORMANCE_CYCLES, ["read"]) ||
  getResource(config.RESOURCES.PERFORMANCE_GOALS, ["read"]) ||
  getResource(config.RESOURCES.PERFORMANCE_KPI_KRA, ["read"]) ||
  getResource(config.RESOURCES.PERFORMANCE_APPRAISAL, ["read"]) ||
  getResource(config.RESOURCES.PERFORMANCE_REPORTS, ["read"]) ||
  getResource(config.RESOURCES.PERFORMANCE_TEMPLATES, ["read"]);

const createYourInfoSubmenu = (keyPrefix = "sub15") => ({
  icon: <i className="fas fa-info-circle" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Your Info",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.leaveApplication,
    MENU_ITEMS.resignation,
    MENU_ITEMS.individualRanking,
    MENU_ITEMS.attendanceRegularization,
    MENU_ITEMS.userAssets,
    MENU_ITEMS.auditHistory,
    MENU_ITEMS.project_overview,
  ].filter(Boolean),
});

const createYourInfoSubmenuForHR = (keyPrefix = "sub15") => ({
  icon: <i className="fas fa-info-circle" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Your Info",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.myInOut,
    MENU_ITEMS.leaveApplication,
    MENU_ITEMS.individualRanking,
    // MENU_ITEMS.userAssets,
    MENU_ITEMS.attendanceRegularization,
    MENU_ITEMS.project_overview,
  ].filter(Boolean),
});

const createYourInfoSubmenuForUser = (keyPrefix = "sub23") => ({
  icon: <i className="fas fa-info-circle" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Your Info",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.leaveApplication,
    MENU_ITEMS.attendanceRegularization,
    MENU_ITEMS.resignation,
    MENU_ITEMS.tickets,
    MENU_ITEMS.userAssets,
    MENU_ITEMS.userReports,
    MENU_ITEMS.individualRanking,
    MENU_ITEMS.goals,
    MENU_ITEMS.auditHistory,
    MENU_ITEMS.project_overview,
  ].filter(Boolean),
});
const createYourInfoSubmenuForNetwork = (keyPrefix = "sub23") => ({
  icon: <i className="fas fa-info-circle" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Your Info",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.leaveApplication,
    MENU_ITEMS.attendanceRegularization,
    MENU_ITEMS.resignation,
    MENU_ITEMS.tickets,
    MENU_ITEMS.userAssets,
    MENU_ITEMS.userReports,
    MENU_ITEMS.individualRanking,
    MENU_ITEMS.goals,
    MENU_ITEMS.audits,
MENU_ITEMS.project_overview,
  ].filter(Boolean),
});

const createMoreSubmenuFoeNetwork = (keyPrefix = "sub18") => ({
  icon: <i className="fas fa-ellipsis-h" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "More",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.lastWorkingDay,
    MENU_ITEMS.jobOpening,
    MENU_ITEMS.organizationPolicy,
    MENU_ITEMS.newJoineesList,
    MENU_ITEMS.manageTickets,

    // MENU_ITEMS.subscription,
    // MENU_ITEMS.billReimbursement,
    // MENU_ITEMS.policies,
    // MENU_ITEMS.goals,
    // MENU_ITEMS.jobOpening,
    // MENU_ITEMS.organizationPolicy,
    // MENU_ITEMS.userReports,
    // MENU_ITEMS.leaveMaster,
    // MENU_ITEMS.employeeLeaveBalance,
    // ...(getResource(config.RESOURCES.WAFFLE, ["read"]) ? [createWaffleSubmenuForAccount()] : []),
  ].filter(Boolean),
});
const createTeamInfoSubmenu = (keyPrefix = "sub16") => ({
  icon: <TeamInfoIcon />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Team Info",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.employeeMaster,
    MENU_ITEMS.employeeInOut,
    MENU_ITEMS.resignationEmployeeList,
    MENU_ITEMS.tickets,
    MENU_ITEMS.manageTeamRegularization,
    MENU_ITEMS.userLeaveApproval,
    MENU_ITEMS.pendingTask,
  ].filter(Boolean),
});

const createTeamInfoSubmenuForHR = (keyPrefix = "sub16") => ({
  icon: <TeamInfoIcon />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Team Info",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.employeeMaster,
    MENU_ITEMS.employeeInOut,
    MENU_ITEMS.resignationEmployeeList,
    MENU_ITEMS.adminReports,
    MENU_ITEMS.tickets,
    MENU_ITEMS.adminLeaveApproval,
    MENU_ITEMS.pendingTask,
    MENU_ITEMS.adminRegularization,
  ].filter(Boolean),
});

const createManagementSubmenu = (keyPrefix = "sub17") => ({
  icon: <PermissionmanagerIcon />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Management",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.achievementsAlt,
    MENU_ITEMS.permission,
    MENU_ITEMS.adminDepartment,
    MENU_ITEMS.adminSubDepartment,
    MENU_ITEMS.meetingRoomMaster,
    MENU_ITEMS.adminDesignation,
    MENU_ITEMS.sourceOfHireMaster,
    MENU_ITEMS.holidays,
    MENU_ITEMS.skills
  ].filter(Boolean),
});

const createOnboardingSubmenu = (keyPrefix = "sub19") => ({
  icon: <OnboardingIcon />,
  className: "main-submenu",
  key: keyPrefix,
  title: "Onboarding",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.candidateApproval,
    MENU_ITEMS.candidateList,
    MENU_ITEMS.onboardingInitiation,
    MENU_ITEMS.docApproveList,
    MENU_ITEMS.newJoineesList,
  ].filter(Boolean),
});

const createMoreSubmenu = (keyPrefix = "sub18") => ({
  icon: <i className="fas fa-ellipsis-h" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "More",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.subscription,
    MENU_ITEMS.billReimbursement,
    MENU_ITEMS.policies,
    MENU_ITEMS.goals,
    MENU_ITEMS.jobOpening,
    MENU_ITEMS.organizationPolicy,
    MENU_ITEMS.userReports,
    MENU_ITEMS.leaveMaster,
    MENU_ITEMS.employeeLeaveBalance,
    ...(getResource(config.RESOURCES.WAFFLE, ["read"]) ? [createWaffleSubmenuForAccount()] : []),
  ].filter(Boolean),
});

const createMoreSubmenuForHR = (keyPrefix = "sub18") => ({
  icon: <i className="fas fa-ellipsis-h" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "More",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.policies,
    MENU_ITEMS.goals,
    MENU_ITEMS.inventory,
    MENU_ITEMS.jobOpening,
    MENU_ITEMS.leaveMaster,
    MENU_ITEMS.employeeLeaveBalance,
    MENU_ITEMS.billReimbursement,
    MENU_ITEMS.mood_analytics,
  ].filter(Boolean),
});

const createMoreSubmenuForRM = (keyPrefix = "sub18") => ({
  icon: <i className="fas fa-ellipsis-h" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "More",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.subscription,
    MENU_ITEMS.jobOpening,
    MENU_ITEMS.organizationPolicy,
    MENU_ITEMS.goals,
    MENU_ITEMS.userReports,
    MENU_ITEMS.newJoineesListAlt,
    // MENU_ITEMS.newJoineesList,
    MENU_ITEMS.candidateList,
    MENU_ITEMS.candidateApproval,
  ].filter(Boolean),
});

const createMoreSubmenuForARM = (keyPrefix = "sub18") => ({
  icon: <i className="fas fa-ellipsis-h" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "More",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.jobOpening,
    MENU_ITEMS.organizationPolicy,
    MENU_ITEMS.goals,
    MENU_ITEMS.userReports,
  ].filter(Boolean),
});

const createMoreSubmenuForRecruiter = (keyPrefix = "sub18") => ({
  icon: <i className="fas fa-ellipsis-h" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "More",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.jobOpening,
    MENU_ITEMS.organizationPolicy,
    MENU_ITEMS.goals,
    MENU_ITEMS.userReports,
  ].filter(Boolean),
});

const createMoreSubmenuForaccountteam = (keyPrefix = "sub18") => ({
  icon: <i className="fas fa-ellipsis-h" />,
  className: "main-submenu",
  key: keyPrefix,
  title: "More",
  submenu: true,
  subMenuInfo: [
    MENU_ITEMS.employeeMaster,
    MENU_ITEMS.lastWorkingDay,
    MENU_ITEMS.employeeInOut,
    MENU_ITEMS.docApproveList,
    // MENU_ITEMS.organizationPolicy,
    MENU_ITEMS.viewEmployeeDetails,
    MENU_ITEMS.organizationPolicy,
    MENU_ITEMS.manageTickets,



    // MENU_ITEMS.newJoineesList,

    // MENU_ITEMS.subscription,
    // MENU_ITEMS.billReimbursement,
    // MENU_ITEMS.policies,
    // MENU_ITEMS.goals,
    // MENU_ITEMS.jobOpening,
    // MENU_ITEMS.organizationPolicy,
    // MENU_ITEMS.userReports,
    // MENU_ITEMS.leaveMaster,
    // MENU_ITEMS.employeeLeaveBalance,
    // ...(getResource(config.RESOURCES.WAFFLE, ["read"]) ? [createWaffleSubmenuForAccount()] : []),
  ].filter(Boolean),
});

// Helper function to filter menu items by permissions
const filterMenuItems = (items) => {
  return items.filter(item => {
    if (!item.permission || item.permission.length === 0) return true;
    return item.permission.some(permission => getResource(permission, ["read"]));
  });
};

// Helper function to conditionally add items
const conditionalItems = (condition, items) => {
  return condition ? items : [];
};

// Role-specific menu configurations
const ROLE_MENUS = {
  User: [
    MENU_ITEMS.dashboard,
    createYourInfoSubmenuForUser(),
    // MENU_ITEMS.leaveApplication,
    // MENU_ITEMS.resignation,
    MENU_ITEMS.lastWorkingDay,
    // MENU_ITEMS.attendanceRegularization,
    // MENU_ITEMS.tickets,
    // MENU_ITEMS.userAssets,
    // MENU_ITEMS.userReports,
    MENU_ITEMS.adminReports,
    // MENU_ITEMS.individualRanking,
    // MENU_ITEMS.goals,
    MENU_ITEMS.jobOpening,
    MENU_ITEMS.organizationPolicy,
    MENU_ITEMS.inventory,
    MENU_ITEMS.manageTickets,
    MENU_ITEMS.auditMaster,
    // MENU_ITEMS.auditHistory,
    MENU_ITEMS.auditPerformance,
    MENU_ITEMS.auditHead,
    MENU_ITEMS.employeeMaster,
    MENU_ITEMS.employeeInOut,
    MENU_ITEMS.adminLeaveApproval,
    MENU_ITEMS.pendingTask,
    MENU_ITEMS.adminRegularization,
    MENU_ITEMS.achievements,
    MENU_ITEMS.permission,
    MENU_ITEMS.adminDepartment,
    MENU_ITEMS.adminSubDepartment,
    MENU_ITEMS.meetingRoomMaster,
    MENU_ITEMS.adminDesignation,
    MENU_ITEMS.sourceOfHireMaster,
    MENU_ITEMS.leaveMaster,
    MENU_ITEMS.employeeLeaveBalance,
    MENU_ITEMS.candidateApproval,
    MENU_ITEMS.candidateList,
    MENU_ITEMS.onboardingInitiation,
    MENU_ITEMS.docApproveList,
    MENU_ITEMS.newJoineesList,
    MENU_ITEMS.holidays,
    MENU_ITEMS.policies,
    ...conditionalItems(getResource(config.RESOURCES.WAFFLE, ["read"]), [MENU_ITEMS.waffleDashboard]),
    MENU_ITEMS.audits,
    MENU_ITEMS.appSettings,
    MENU_ITEMS.employeeInOut,
    MENU_ITEMS.resignationEmployeeList,
    MENU_ITEMS.manageTeamRegularization,
    // MENU_ITEMS.userLeaveApproval,
    MENU_ITEMS.viewEmployeeDetails,
    MENU_ITEMS.billReimbursement,
    MENU_ITEMS.organizationTree,
    ...conditionalItems(userdata?._id == "68b5673ddbd1f7003fef2c81", [MENU_ITEMS.mira]),
    ...conditionalItems(
      getResource(config.RESOURCES.KPI_KRA, ["read"]) ||
      getResource(config.RESOURCES.KPI_REVIEWER, ["read"]) ||
      getResource(config.RESOURCES.KPI_EMPLOYEE, ["read"]),
      [createKpiSubmenu("sub-kpi-user")]
    ),
    ...conditionalItems(hasPerformanceAccess(), [createPerformanceSubmenu("sub-performance-user")]),
  ],

  // Receptionist = same as User, plus the read-only "Reporting Managers' Pending
  // Tasks" screen (gated by the RM_PENDING_TASK resource, which only Receptionist holds).
  Receptionist: [
    MENU_ITEMS.dashboard,
    createYourInfoSubmenuForUser(),
    MENU_ITEMS.lastWorkingDay,
    MENU_ITEMS.adminReports,
    MENU_ITEMS.jobOpening,
    MENU_ITEMS.organizationPolicy,
    MENU_ITEMS.inventory,
    MENU_ITEMS.manageTickets,
    MENU_ITEMS.auditMaster,
    MENU_ITEMS.auditPerformance,
    MENU_ITEMS.auditHead,
    MENU_ITEMS.employeeMaster,
    MENU_ITEMS.employeeInOut,
    MENU_ITEMS.adminLeaveApproval,
    MENU_ITEMS.pendingTask,
    MENU_ITEMS.reportingManagersPendingTask,
    MENU_ITEMS.adminRegularization,
    MENU_ITEMS.achievements,
    MENU_ITEMS.permission,
    MENU_ITEMS.adminDepartment,
    MENU_ITEMS.adminSubDepartment,
    MENU_ITEMS.meetingRoomMaster,
    MENU_ITEMS.adminDesignation,
    MENU_ITEMS.sourceOfHireMaster,
    MENU_ITEMS.leaveMaster,
    MENU_ITEMS.employeeLeaveBalance,
    MENU_ITEMS.candidateApproval,
    MENU_ITEMS.candidateList,
    MENU_ITEMS.onboardingInitiation,
    MENU_ITEMS.docApproveList,
    MENU_ITEMS.newJoineesList,
    MENU_ITEMS.holidays,
    MENU_ITEMS.policies,
    ...conditionalItems(getResource(config.RESOURCES.WAFFLE, ["read"]), [MENU_ITEMS.waffleDashboard]),
    MENU_ITEMS.audits,
    MENU_ITEMS.appSettings,
    MENU_ITEMS.employeeInOut,
    MENU_ITEMS.resignationEmployeeList,
    MENU_ITEMS.manageTeamRegularization,
    MENU_ITEMS.viewEmployeeDetails,
    MENU_ITEMS.billReimbursement,
    MENU_ITEMS.organizationTree,
    ...conditionalItems(
      getResource(config.RESOURCES.KPI_KRA, ["read"]) ||
      getResource(config.RESOURCES.KPI_REVIEWER, ["read"]) ||
      getResource(config.RESOURCES.KPI_EMPLOYEE, ["read"]),
      [createKpiSubmenu("sub-kpi-receptionist")]
    ),
    ...conditionalItems(hasPerformanceAccess(), [createPerformanceSubmenu("sub-performance-receptionist")]),
  ],

  Account: [
    MENU_ITEMS.dashboard,
    createYourInfoSubmenuForUser(),
    createMoreSubmenuForaccountteam(),

    // MENU_ITEMS.leaveApplication,
    // MENU_ITEMS.resignation,
    // MENU_ITEMS.lastWorkingDay,
    // MENU_ITEMS.attendanceRegularization,
    // MENU_ITEMS.tickets,
    // MENU_ITEMS.userAssets,
    // MENU_ITEMS.userReports,/
    // MENU_ITEMS.adminReports,
    // MENU_ITEMS.individualRanking,
    // MENU_ITEMS.goals,
    // MENU_ITEMS.jobOpening,
    // MENU_ITEMS.inventory,
    // MENU_ITEMS.manageTickets,
    // MENU_ITEMS.auditMaster,
    // MENU_ITEMS.auditHistory,
    // MENU_ITEMS.auditPerformance,
    // MENU_ITEMS.auditHead,
 
    // MENU_ITEMS.adminLeaveApproval,
    // MENU_ITEMS.pendingTask,
    // MENU_ITEMS.adminRegularization,
    // MENU_ITEMS.achievementsAlt,
    // MENU_ITEMS.permission,
    // MENU_ITEMS.adminDepartment,
    // MENU_ITEMS.adminDesignation,
    // MENU_ITEMS.leaveMaster,
    // MENU_ITEMS.employeeLeaveBalance,
    // MENU_ITEMS.candidateApproval,
    // MENU_ITEMS.candidateList,
    // MENU_ITEMS.onboardingInitiation,
    // MENU_ITEMS.docApproveList,
    // MENU_ITEMS.newJoineesList,
    // MENU_ITEMS.holidays,
    // MENU_ITEMS.policies,
    // MENU_ITEMS.audits,
    // MENU_ITEMS.appSettings,
    // MENU_ITEMS.employeeInOut,
    // MENU_ITEMS.resignationEmployeeList,
    // MENU_ITEMS.manageTeamRegularization,
    // MENU_ITEMS.userLeaveApproval,
    // MENU_ITEMS.onboardingInitiation,
    ...conditionalItems(getResource(config.RESOURCES.WAFFLE, ["read"]), [createWaffleSubmenuForAccount("sub17")]),
    // createMoreSubmenu(),
    ...conditionalItems(
      getResource(config.RESOURCES.KPI_KRA, ["read"]) ||
      getResource(config.RESOURCES.KPI_REVIEWER, ["read"]) ||
      getResource(config.RESOURCES.KPI_EMPLOYEE, ["read"]),
      [createKpiSubmenu("sub-kpi-account")]
    ),
    ...conditionalItems(hasPerformanceAccess(), [createPerformanceSubmenu("sub-performance-account")]),
    MENU_ITEMS.organizationTree
  ],

  Auditor: [
    MENU_ITEMS.dashboard,
    MENU_ITEMS.leaveApplication,
    MENU_ITEMS.resignation,
    MENU_ITEMS.lastWorkingDay,
    MENU_ITEMS.attendanceRegularization,
    MENU_ITEMS.tickets,
    MENU_ITEMS.userAssets,
    MENU_ITEMS.userReports,
    MENU_ITEMS.adminReports,
    MENU_ITEMS.individualRanking,
    MENU_ITEMS.goals,
    MENU_ITEMS.jobOpening,
    MENU_ITEMS.organizationPolicy,
    MENU_ITEMS.inventory,
    MENU_ITEMS.manageTickets,
    ...conditionalItems(
      getResource(config.RESOURCES.AUDIT_MASTER, ["read"]) ||
      getResource(config.RESOURCES.AUDITS, ["read"]) ||
      getResource(config.RESOURCES.AUDITS_PERFORMANCE, ["read"]) ||
      getResource(config.RESOURCES.AUDIT_HEAD, ["read"]),
      [createAuditSubmenu()]
    ),
    MENU_ITEMS.employeeMaster,
    MENU_ITEMS.employeeInOut,
    MENU_ITEMS.adminLeaveApproval,
    MENU_ITEMS.pendingTask,
    MENU_ITEMS.adminRegularization,
    MENU_ITEMS.achievementsAlt,
    MENU_ITEMS.permission,
    MENU_ITEMS.adminDepartment,
    MENU_ITEMS.adminSubDepartment,
    MENU_ITEMS.meetingRoomMaster,
    MENU_ITEMS.adminDesignation,
    MENU_ITEMS.sourceOfHireMaster,
    MENU_ITEMS.leaveMaster,
    MENU_ITEMS.employeeLeaveBalance,
    MENU_ITEMS.candidateApproval,
    MENU_ITEMS.candidateList,
    MENU_ITEMS.onboardingInitiation,
    MENU_ITEMS.docApproveList,
    MENU_ITEMS.newJoineesList,
    MENU_ITEMS.holidays,
    MENU_ITEMS.policies,
    MENU_ITEMS.appSettings,
    MENU_ITEMS.resignationEmployeeList,
    MENU_ITEMS.manageTeamRegularization,
    // MENU_ITEMS.userLeaveApproval,
    MENU_ITEMS.viewEmployeeDetails,
    ...conditionalItems(getResource(config.RESOURCES.WAFFLE, ["read"]), [createWaffleSubmenuForAccount("sub17")]),
    ...conditionalItems(
      getResource(config.RESOURCES.KPI_KRA, ["read"]) ||
      getResource(config.RESOURCES.KPI_REVIEWER, ["read"]) ||
      getResource(config.RESOURCES.KPI_EMPLOYEE, ["read"]),
      [createKpiSubmenu("sub-kpi-auditor")]
    ),
    ...conditionalItems(hasPerformanceAccess(), [createPerformanceSubmenu("sub-performance-auditor")]),
    MENU_ITEMS.organizationTree
  ],

  Reporting_Manager: [
    MENU_ITEMS.adminDashboard,
    ...conditionalItems(
      getResource(config.RESOURCES.LEAVE, ["read"]) ||
      getResource(config.RESOURCES.RANKING, ["read"]) ||
      getResource(config.RESOURCES.ATTENDANCE_REGULARIZATION, ["read"]) ||
      getResource(config.RESOURCES.MY_ASSETS, ["read"]),
      [createYourInfoSubmenu("sub15")]
    ),
    ...conditionalItems(
      getResource(config.RESOURCES.EMPLOYEE_MASTER, ["read"]) ||
      getResource(config.RESOURCES.EMPLOYEE_IN_OUT, ["read"]) ||
      getResource(config.RESOURCES.SEPARATION_MANAGEMENT, ["read"]) ||
      getResource(config.RESOURCES.TICKET, ["read"]) ||
      getResource(config.RESOURCES.TEAM_REGULARIZATION, ["read"]) ||
      getResource(config.RESOURCES.LEAVE_MANAGEMENT, ["read"]) ||
      getResource(config.RESOURCES.PENDING_TASK, ["read"]),
      [createTeamInfoSubmenu("sub16")]
    ),
    ...conditionalItems(
      userdata?._id === "63b6ca8870f2b5b3002cb446",
      [createAuditSubmenu("sub20")]
    ),
    ...conditionalItems(getResource(config.RESOURCES.WAFFLE, ["read"]), [MENU_ITEMS.waffleDashboard]),
    MENU_ITEMS.lastWorkingDay,
    MENU_ITEMS.inventory,
    MENU_ITEMS.manageTickets,
    MENU_ITEMS.auditMaster,
    MENU_ITEMS.auditPerformance,
    MENU_ITEMS.auditHead,
    MENU_ITEMS.adminLeaveApproval,
    MENU_ITEMS.adminRegularization,
    MENU_ITEMS.achievementsAlt,
    MENU_ITEMS.permission,
    MENU_ITEMS.adminDepartment,
    MENU_ITEMS.adminSubDepartment,
    MENU_ITEMS.meetingRoomMaster,
    MENU_ITEMS.adminDesignation,
    MENU_ITEMS.sourceOfHireMaster,
    MENU_ITEMS.leaveMaster,
    MENU_ITEMS.employeeLeaveBalance,
    MENU_ITEMS.onboardingInitiation,
    MENU_ITEMS.docApproveList,
    MENU_ITEMS.holidays,
    MENU_ITEMS.policies,
    MENU_ITEMS.audits,
    MENU_ITEMS.appSettings,
    MENU_ITEMS.viewEmployeeDetails,
    createMoreSubmenuForRM(),
    ...conditionalItems(
      getResource(config.RESOURCES.KPI_KRA, ["read"]) ||
      getResource(config.RESOURCES.KPI_REVIEWER, ["read"]) ||
      getResource(config.RESOURCES.KPI_EMPLOYEE, ["read"]),
      [createKpiSubmenu("sub-kpi-rm")]
    ),
    ...conditionalItems(hasPerformanceAccess(), [createPerformanceSubmenu("sub-performance-rm")]),
    MENU_ITEMS.organizationTree
  ],

  Assistant_Reporting_Manager: [
    MENU_ITEMS.adminDashboard,
    ...conditionalItems(
      getResource(config.RESOURCES.LEAVE, ["read"]) ||
      getResource(config.RESOURCES.SEPARATION, ["read"]) ||
      getResource(config.RESOURCES.RANKING, ["read"]) ||
      getResource(config.RESOURCES.ATTENDANCE_REGULARIZATION, ["read"]) ||
      getResource(config.RESOURCES.MY_ASSETS, ["read"]),
      [createYourInfoSubmenu("sub15")]
    ),
    ...conditionalItems(
      getResource(config.RESOURCES.EMPLOYEE_MASTER, ["read"]) ||
      getResource(config.RESOURCES.EMPLOYEE_IN_OUT, ["read"]) ||
      getResource(config.RESOURCES.TICKET, ["read"]) ||
      getResource(config.RESOURCES.TEAM_REGULARIZATION, ["read"]) ||
      getResource(config.RESOURCES.LEAVE_MANAGEMENT, ["read"]) ||
      getResource(config.RESOURCES.PENDING_TASK, ["read"]),
      [createTeamInfoSubmenu("sub16")]
    ),
    MENU_ITEMS.auditHistory,
    MENU_ITEMS.lastWorkingDay,
    MENU_ITEMS.adminReports,
    MENU_ITEMS.inventory,
    MENU_ITEMS.manageTickets,
    MENU_ITEMS.auditMaster,
    MENU_ITEMS.auditPerformance,
    MENU_ITEMS.auditHead,
    MENU_ITEMS.adminLeaveApproval,
    MENU_ITEMS.adminRegularization,
    MENU_ITEMS.achievementsAlt,
    MENU_ITEMS.permission,
    MENU_ITEMS.adminDepartment,
    MENU_ITEMS.adminSubDepartment,
    MENU_ITEMS.meetingRoomMaster,
    MENU_ITEMS.adminDesignation,
    MENU_ITEMS.sourceOfHireMaster,
    MENU_ITEMS.leaveMaster,
    MENU_ITEMS.employeeLeaveBalance,
    MENU_ITEMS.onboardingInitiation,
    MENU_ITEMS.docApproveList,
    MENU_ITEMS.newJoineesList,
    MENU_ITEMS.holidays,
    MENU_ITEMS.policies,
    MENU_ITEMS.audits,
    MENU_ITEMS.appSettings,
    MENU_ITEMS.viewEmployeeDetails,
    ...conditionalItems(getResource(config.RESOURCES.WAFFLE, ["read"]), [createWaffleSubmenuForAssistantRM("sub17")]),
    createMoreSubmenuForARM(),
    ...conditionalItems(
      getResource(config.RESOURCES.KPI_KRA, ["read"]) ||
      getResource(config.RESOURCES.KPI_REVIEWER, ["read"]) ||
      getResource(config.RESOURCES.KPI_EMPLOYEE, ["read"]),
      [createKpiSubmenu("sub-kpi-arm")]
    ),
    ...conditionalItems(hasPerformanceAccess(), [createPerformanceSubmenu("sub-performance-arm")]),
    MENU_ITEMS.organizationTree
  ],

  Network_Team: [
    MENU_ITEMS.dashboard,

    createYourInfoSubmenuForNetwork(),
    createMoreSubmenuFoeNetwork(),
    // MENU_ITEMS.leaveApplication,
    // MENU_ITEMS.resignation,
    MENU_ITEMS.inventory,
    // MENU_ITEMS.audits,
   
    // createAuditSubmenu(),

    MENU_ITEMS.employeeMaster,
    MENU_ITEMS.employeeInOut,
    MENU_ITEMS.adminLeaveApproval,
    MENU_ITEMS.pendingTask,
    MENU_ITEMS.adminRegularization,
    MENU_ITEMS.achievementsAlt,
    MENU_ITEMS.permission,
    MENU_ITEMS.adminDepartment,
    MENU_ITEMS.adminSubDepartment,
    MENU_ITEMS.meetingRoomMaster,
    MENU_ITEMS.adminDesignation,
    MENU_ITEMS.sourceOfHireMaster,
    MENU_ITEMS.leaveMaster,
    MENU_ITEMS.employeeLeaveBalance,
    MENU_ITEMS.onboardingInitiation,
    MENU_ITEMS.docApproveList,
    // MENU_ITEMS.newJoineesList,
    MENU_ITEMS.holidays,
    MENU_ITEMS.policies,
    // MENU_ITEMS.audits,
    MENU_ITEMS.appSettings,
    MENU_ITEMS.resignationEmployeeList,
    MENU_ITEMS.manageTeamRegularization,
    // MENU_ITEMS.userLeaveApproval,
    MENU_ITEMS.viewEmployeeDetails,
    ...conditionalItems(getResource(config.RESOURCES.WAFFLE, ["read"]), [createWaffleSubmenuForAccount("sub17")]),
    ...conditionalItems(
      getResource(config.RESOURCES.KPI_KRA, ["read"]) ||
      getResource(config.RESOURCES.KPI_REVIEWER, ["read"]) ||
      getResource(config.RESOURCES.KPI_EMPLOYEE, ["read"]),
      [createKpiSubmenu("sub-kpi-nteam")]
    ),
    ...conditionalItems(hasPerformanceAccess(), [createPerformanceSubmenu("sub-performance-nteam")]),
    MENU_ITEMS.organizationTree
  ],

  HR: [
    MENU_ITEMS.dashboard,
    ...conditionalItems(
      getResource(config.RESOURCES.EMPLOYEE_IN_OUT, ["read"]) ||
      getResource(config.RESOURCES.LEAVE, ["read"]) ||
      getResource(config.RESOURCES.RANKING, ["read"]) ||
      getResource(config.RESOURCES.MY_ASSETS, ["read"]),
      [createYourInfoSubmenuForHR("sub15")]
    ),
    ...conditionalItems(
      getResource(config.RESOURCES.EMPLOYEE_MASTER, ["read"]) ||
      getResource(config.RESOURCES.EMPLOYEE_IN_OUT, ["read"]) ||
      getResource(config.RESOURCES.SEPARATION_MANAGEMENT, ["read"]) ||
      getResource(config.RESOURCES.EMPLOYEE_REPORT, ["read"]) ||
      getResource(config.RESOURCES.TICKET, ["read"]) ||
      getResource(config.RESOURCES.ADMIN_LEAVE_MANAGEMENT, ["read"]) ||
      getResource(config.RESOURCES.PENDING_TASK, ["read"]) ||
      getResource(config.RESOURCES.ADMIN_REGULARIZATION, ["read"]),
      [createTeamInfoSubmenuForHR("sub16")]
    ),
    ...conditionalItems(
      getResource(config.RESOURCES.ACHIEVEMENTS, ["read"]) ||
      getResource(config.RESOURCES.SETTINGS, ["read"]) ||
      getResource(config.RESOURCES.DEPARTMENTS, ["read"]) ||
      getResource(config.RESOURCES.DESIGNATION, ["read"]) ||
      getResource(config.RESOURCES.HOLIDAYS, ["read"]),
      [createManagementSubmenu("sub17")]
    ),
    ...conditionalItems(
      getResource(config.RESOURCES.ON_BOARDING_INITIATION, ["read"]) ||
      getResource(config.RESOURCES.ON_BOARDING_DOC_APPROVAL_LIST, ["read"]) ||
      getResource(config.RESOURCES.NEW_JOINEES, ["read"]),
      [createOnboardingSubmenu("sub19")]
    ),
    // MENU_ITEMS.inventory,
    ...conditionalItems(
      getResource(config.RESOURCES.AUDIT_MASTER, ["read"]) ||
      getResource(config.RESOURCES.AUDITS, ["read"]) ||
      getResource(config.RESOURCES.AUDITS_PERFORMANCE, ["read"]) ||
      getResource(config.RESOURCES.AUDIT_HEAD, ["read"]),
      [createAuditSubmenuForHR("sub20")]
    ),
    // MENU_ITEMS.userLeaveApproval,
    MENU_ITEMS.appSettings,
    MENU_ITEMS.manageTeamRegularization,
    MENU_ITEMS.viewEmployeeDetails,
    ...conditionalItems(getResource(config.RESOURCES.WAFFLE, ["read"]), [createWaffleSubmenuForHR("sub21")]),
    ...conditionalItems(
      getResource(config.RESOURCES.POLICIES, ["read"]) ||
      getResource(config.RESOURCES.MY_GOAL, ["read"]) ||
      getResource(config.RESOURCES.JOB_OPENING, ["read"]) ||
      getResource(config.RESOURCES.BILLREIMBURSEMENT, ["read"]),
      [createMoreSubmenuForHR("sub18")]
    ),
    ...conditionalItems(
      getResource(config.RESOURCES.KPI_KRA, ["read"]) ||
      getResource(config.RESOURCES.KPI_REVIEWER, ["read"]) ||
      getResource(config.RESOURCES.KPI_EMPLOYEE, ["read"]),
      [createKpiSubmenu("sub-kpi-hr")]
    ),
    ...conditionalItems(hasPerformanceAccess(), [createPerformanceSubmenu("sub-performance-hr")]),
    MENU_ITEMS.organizationTree
  ],

  Intern: [
    MENU_ITEMS.dashboard,
    MENU_ITEMS.leaveApplication,
    MENU_ITEMS.resignation,
    MENU_ITEMS.lastWorkingDay,
    MENU_ITEMS.attendanceRegularization,
    MENU_ITEMS.tickets,
    MENU_ITEMS.userAssets,
    MENU_ITEMS.userReports,
    MENU_ITEMS.adminReports,
    MENU_ITEMS.individualRanking,
    MENU_ITEMS.goals,
    MENU_ITEMS.jobOpening,
    MENU_ITEMS.organizationPolicy,
    MENU_ITEMS.inventory,
    MENU_ITEMS.manageTickets,
    MENU_ITEMS.auditMaster,
    MENU_ITEMS.auditHistory,
    MENU_ITEMS.auditPerformance,
    MENU_ITEMS.auditHead,
    MENU_ITEMS.employeeMaster,
    MENU_ITEMS.employeeInOut,
    MENU_ITEMS.adminLeaveApproval,
    MENU_ITEMS.pendingTask,
    MENU_ITEMS.adminRegularization,
    MENU_ITEMS.achievementsAlt,
    MENU_ITEMS.permission,
    MENU_ITEMS.adminDepartment,
    MENU_ITEMS.adminSubDepartment,
    MENU_ITEMS.meetingRoomMaster,
    MENU_ITEMS.adminDesignation,
    MENU_ITEMS.sourceOfHireMaster,
    MENU_ITEMS.leaveMaster,
    MENU_ITEMS.employeeLeaveBalance,
    MENU_ITEMS.onboardingInitiation,
    MENU_ITEMS.docApproveList,
    MENU_ITEMS.newJoineesList,
    MENU_ITEMS.holidays,
    MENU_ITEMS.policies,
    MENU_ITEMS.audits,
    MENU_ITEMS.appSettings,
    MENU_ITEMS.resignationEmployeeList,
    MENU_ITEMS.manageTeamRegularization,
    // MENU_ITEMS.userLeaveApproval,
    MENU_ITEMS.viewEmployeeDetails,
    ...conditionalItems(getResource(config.RESOURCES.WAFFLE, ["read"]), [createWaffleSubmenuForIntern("sub17")]),
    ...conditionalItems(
      getResource(config.RESOURCES.KPI_KRA, ["read"]) ||
      getResource(config.RESOURCES.KPI_REVIEWER, ["read"]) ||
      getResource(config.RESOURCES.KPI_EMPLOYEE, ["read"]),
      [createKpiSubmenu("sub-kpi-intern")]
    ),
    ...conditionalItems(hasPerformanceAccess(), [createPerformanceSubmenu("sub-performance-intern")]),
    MENU_ITEMS.organizationTree
  ],

  Recruiter: [
    MENU_ITEMS.adminDashboard,
    ...conditionalItems(
      getResource(config.RESOURCES.LEAVE, ["read"]) ||
      getResource(config.RESOURCES.SEPARATION, ["read"]) ||
      getResource(config.RESOURCES.RANKING, ["read"]) ||
      getResource(config.RESOURCES.ATTENDANCE_REGULARIZATION, ["read"]) ||
      getResource(config.RESOURCES.MY_ASSETS, ["read"]),
      [createYourInfoSubmenu("sub15")]
    ),
    ...conditionalItems(
      getResource(config.RESOURCES.EMPLOYEE_MASTER, ["read"]) ||
      getResource(config.RESOURCES.EMPLOYEE_IN_OUT, ["read"]) ||
      getResource(config.RESOURCES.TICKET, ["read"]) ||
      getResource(config.RESOURCES.TEAM_REGULARIZATION, ["read"]) ||
      getResource(config.RESOURCES.LEAVE_MANAGEMENT, ["read"]) ||
      getResource(config.RESOURCES.PENDING_TASK, ["read"]),
      [createTeamInfoSubmenu("sub16")]
    ),
    MENU_ITEMS.auditHistoryAlt,
    MENU_ITEMS.lastWorkingDay,
    MENU_ITEMS.adminReports,
    MENU_ITEMS.inventory,
    MENU_ITEMS.manageTickets,
    MENU_ITEMS.auditMaster,
    MENU_ITEMS.auditPerformance,
    MENU_ITEMS.auditHead,
    MENU_ITEMS.adminLeaveApproval,
    MENU_ITEMS.adminRegularization,
    MENU_ITEMS.achievementsAlt,
    MENU_ITEMS.permission,
    MENU_ITEMS.adminDepartment,
    MENU_ITEMS.adminSubDepartment,
    MENU_ITEMS.meetingRoomMaster,
    MENU_ITEMS.adminDesignation,
    MENU_ITEMS.sourceOfHireMaster,
    MENU_ITEMS.leaveMaster,
    MENU_ITEMS.employeeLeaveBalance,
    MENU_ITEMS.candidateApprovalAlt,
    MENU_ITEMS.candidateListAlt,
    MENU_ITEMS.onboardingInitiation,
    MENU_ITEMS.docApproveList,
    MENU_ITEMS.newJoineesList,
    MENU_ITEMS.holidays,
    MENU_ITEMS.policies,
    MENU_ITEMS.audits,
    MENU_ITEMS.appSettings,
    MENU_ITEMS.viewEmployeeDetails,
    ...conditionalItems(getResource(config.RESOURCES.WAFFLE, ["read"]), [createWaffleSubmenuForAccount("sub17")]),
    createMoreSubmenuForRecruiter(),
    ...conditionalItems(
      getResource(config.RESOURCES.KPI_KRA, ["read"]) ||
      getResource(config.RESOURCES.KPI_REVIEWER, ["read"]) ||
      getResource(config.RESOURCES.KPI_EMPLOYEE, ["read"]),
      [createKpiSubmenu("sub-kpi-recruiter")]
    ),
    ...conditionalItems(hasPerformanceAccess(), [createPerformanceSubmenu("sub-performance-recruiter")]),
    MENU_ITEMS.organizationTree
  ],
};

// Main export function that returns the menu for a specific role
export const getMenuForRole = (role) => {
  const menu = ROLE_MENUS[role] || [];
  return filterMenuItems(menu);
};

// Maintain backward compatibility with existing exports
export const User = getMenuForRole('User');
export const Account = getMenuForRole('Account');
export const Auditor = getMenuForRole('Auditor');
export const Reporting_Manager = getMenuForRole('Reporting_Manager');
export const Assistant_Reporting_Manager = getMenuForRole('Assistant_Reporting_Manager');
export const Network_Team = getMenuForRole('Network_Team');
export const HR = getMenuForRole('HR');
export const Intern = getMenuForRole('Intern');
export const Recruiter = getMenuForRole('Recruiter');
export const Receptionist = getMenuForRole('Receptionist');

// Export helper functions for potential reuse
export { MENU_ITEMS, filterMenuItems, conditionalItems };

